import { useBreakpointValue } from "@chakra-ui/react";
import { Key, useEffect, useRef } from "react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import useScreen from "../../hooks/useScreen";
// import { Color } from "../../interfaces/HairTransfer";
import { ColorItem } from "../HairTonalityItem/HairTonalityItem";
import { NavigationButton } from "../SwiperNavigationButton/NavigationButton";

SwiperCore.use([Navigation]);

interface hairColorCarrouselProps {
  selectedColor: any;
  colorList: any;
  screen: string;
  disable?: boolean;
  isByColor?: boolean;
}

export const HairColorTonality = (props: hairColorCarrouselProps) => {
  const { selectedColor, colorList, screen, disable, isByColor } = props;
  const { isMobile } = useScreen();
  const swiperSubRef = useRef<SwiperCore>();

  const slidesPerViewColorTonality = useBreakpointValue({
    base: 6,
    sm: 9.5,
    md: 7.4,
    lg: 9.5,
  });

  useEffect(() => {
    swiperSubRef.current?.slideTo(0, 300);
  }, [isByColor, colorList]);

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          position: "relative",
          paddingBottom: isMobile ? "0" : "0px",
          width: isMobile ? "100%" : "70%",
          margin: isMobile ? "0" : "0 auto",
        }}
      >
        <Swiper
          onInit={(core: SwiperCore) => (swiperSubRef.current = core)}
          slidesPerView={slidesPerViewColorTonality}
          spaceBetween={17}
          style={{
            paddingLeft: isMobile ? "16px" : "0",
            paddingRight: isMobile ? "16px" : "0",
            paddingBottom: "16px",
            paddingTop: "16px",
          }}
          navigation={
            isMobile
              ? false
              : {
                  nextEl: ".swiper-button-next-color-tonality",
                  prevEl: ".swiper-button-prev-color-tonality",
                }
          }
          centerInsufficientSlides={true}
          observer={true}
          observeParents={true}
          observeSlideChildren={true}
        >
          {colorList.map((item: any, index: Key | null | undefined) => (
            <SwiperSlide key={index} style={{ display: "flex" }}>
              <ColorItem
                color={item}
                colorList={colorList}
                selected={selectedColor === item}
                screen={screen}
                disable={disable}
                isByColor={isByColor}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {!isMobile && (
          <>
            <NavigationButton
              direction="right"
              className="swiper-button-next-color-tonality"
            />

            <NavigationButton
              direction="left"
              className="swiper-button-prev-color-tonality"
            />
          </>
        )}
      </div>
    </div>
  );
};
